import React, { createContext, useContext, useMemo } from "react";
import mx from "./mx.json";
import en from "./en.json";

const dictionaries = { mx, en };

const I18nContext = createContext({
  lang: "mx",
  t: (key) => key,
});

function getByPath(obj, path) {
  return path.split(".").reduce((acc, part) => {
    if (acc && Object.prototype.hasOwnProperty.call(acc, part)) return acc[part];
    return undefined;
  }, obj);
}

export const I18nProvider = ({ lang, children }) => {
  const value = useMemo(() => {
    const active = dictionaries[lang] || dictionaries.mx;
    const fallback = dictionaries.mx;
    const t = (key) => {
      const v = getByPath(active, key);
      if (typeof v === "string") return v;
      const f = getByPath(fallback, key);
      return typeof f === "string" ? f : key;
    };
    return { lang, t };
  }, [lang]);

  return <I18nContext.Provider value={value}>{children}</I18nContext.Provider>;
};

export const useI18n = () => useContext(I18nContext);
